<template lang='pug'>
  el-upload.upload-image-container(
    action="#"
    :auto-upload="false"
    list-type="picture-card"
    :on-change="(file,fileList) => {uploadFile(file, fileList,index, idx)}"
    :file-list="fileLists[index][idx]"
    multiple
  )
    div(
      slot="file"
      slot-scope="{file}"
    )
      template(
        v-if="file.url.endsWith('.jpg') || file.url.endsWith('.jpeg') || file.url.endsWith('.gif') || file.url.endsWith('.png')"
      )
        img.el-upload-list__item-thumbnail(
          :src="file.url"
        )
        span.el-upload-list__item-actions
          //- span(
          //-   @click="handlePreview(file.url)"
          //- )
          //-   i.el-icon-zoom-in
          span(
            @click="handleRemove(file)"
          )
            i.el-icon-delete
      template(v-else)
        img.el-upload-list__item-thumbnail(
          :src="getFileCover(file.url)"
        )
        span.el-upload-list__item-actions
          span(
            v-if="file.url"
            @click="handleDownload(file, index, idx)"
          )
            i.el-icon-download
          span(
            @click="handleRemove(file)"
          )
            i.el-icon-delete
    div(
      style="height: 60px;line-height:30px"
    )
      i(
        class="el-icon-plus"
      )
      span(style="display:block") {{ $t('点击上传') }}
    preview-img(ref="PreviewImg" :edit='false')
</template>

<script>
import { postfixToImgCode } from '@/umcc/constant'
import PreviewImg from '@/components/PreviewImg/index'
import axios from 'axios'
// file is an img
const getImgSize = file => {
  return new Promise((resolve, reject) => {
    const fr = new FileReader()

    fr.onload = () => {
      const img = new Image()

      img.onload = function () {
        resolve({width: img.width, height: img.height})
      }

      img.onerror = function () {
        reject(new Error(this.$t('图片加载失败')))
      }

      img.src = fr.result
    }

    fr.onerror = () => {
      reject(new Error(this.$t('文件读取失败')))
    }

    fr.readAsDataURL(file)
  })
}

const getVideoSize = file => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video')

    video.addEventListener('loadedmetadata', () => {
      resolve({
        height: video.videoHeight,
        width: video.videoWidth
      })
    })

    const fr = new FileReader()
    fr.addEventListener('load', () => {
      video.src = fr.result
    })
    fr.readAsDataURL(file)
  })
}

// file: Browser File Object
// return error string
// empty means ok
const isFileValid = async (file, categoryName) => {
  const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/gif'
  const isVideo = file.type === 'video/mp4' || file.type === 'video/mpeg' || file.type === 'video/3gp' || file.type === 'video/avi'
  let imgSize = {}
  let videoSize = {}
  if (isJPG) {
    imgSize = await getImgSize(file)
  }

  if (isVideo) {
    videoSize = await getVideoSize(file)
  }
  switch (categoryName) {
    case 'RTB-付费搜索':
      if (!isJPG) {
        return {
          errMsg: this.$t('上传图片只能是 JPG/JPEG/PNG 格式')
        }
      }

      if (imgSize.width !== 800 & imgSize.height !== 800) {
        return {
          errMsg: this.$t('素材要求') + ': 800 * 800'
        }
      }

      if (file.size / 1024 > 150) {
        return {
          errMsg: this.$t('上传图片大小不能超过') + ' 150k'
        }
      }

      break
    case 'RTB-首焦':
      if (!isJPG) {
        return {
          errMsg: this.$t('上传图片只能是 JPG/JPEG/PNG 格式')
        }
      }

      if (file.type === 'image/gif') {
        if (imgSize.width !== 640 & imgSize.height !== 200) {
          return {
            errMsg: this.$t('素材要求') + ': 640 * 200'
          }
        }

        if (file.size / 1024 > 600) {
          return {
            errMsg: this.$t('上传图片大小不能超过') + ' 600k'
          }
        }
        break
      } else {
        if (imgSize.width === 640) {
          if (imgSize.height !== 200) {
            return {
              errMsg: this.$t('素材要求') + ': 640 * 200 , 1120 * 350'
            }
          }
        } else if (imgSize.width === 1120) {
          if (imgSize.height !== 350) {
            return {
              errMsg: this.$t('素材要求') + ': 640 * 200 , 1120 * 350'
            }
          }
        } else {
          return {
            errMsg: this.$t('素材要求') + ': 640 * 200 , 1120 * 350'
          }
        }

        if (file.size / 1024 > 200) {
          return {
            errMsg: this.$t('上传图片大小不能超过') + ' 200k'
          }
        }
      }
      break
    case 'RTB-超级推荐':
      if (!isJPG) {
        return {
          errMsg: this.$t('上传图片只能是 JPG/JPEG/PNG 格式')
        }
      }

      if (imgSize.width !== 800 & (imgSize.height !== 800 || imgSize.height !== 1200)) {
        return {
          errMsg: this.$t('素材要求') + ': 800 * 800 , 800 * 1200'
        }
      }

      if (file.size / 1024 > 500) {
        return {
          errMsg: this.$t('上传图片大小不能超过') + ' 500k'
        }
      }
      break
    case '明星店铺':
      if (!isJPG) {
        return {
          errMsg: this.$t('上传图片只能是 JPG/JPEG/PNG 格式')
        }
      }

      if (imgSize.width !== 688 & imgSize.height !== 340) {
        return {
          errMsg: this.$t('素材要求') + ': 600 * 340'
        }
      }

      if (file.size / 1024 > 500) {
        return {
          errMsg: this.$t('上传图片大小不能超过') + ' 500k'
        }
      }
      break
    case 'CPD-品牌专区':
      if (!isJPG) {
        return {
          errMsg: this.$t('上传图片只能是 JPG/JPEG/PNG 格式')
        }
      }

      if (imgSize.width !== 750 & imgSize.height !== 360) {
        return {
          errMsg: this.$t('素材要求') + ': 750 * 360'
        }
      }

      if (file.size / 1024 > 60) {
        return {
          errMsg: this.$t('上传图片大小不能超过') + ' 60k'
        }
      }
      break
    case 'RTB-外投媒体（抖音）':
      if (!isVideo) {
        return {
          errMsg: this.$t('上传视频只能是 MP4/MPEG/3GP/AVI 格式')
        }
      }

      if (videoSize.width !== 540 & videoSize.height !== 960) {
        return {
          errMsg: this.$t('素材要求') + ': 540 * 960'
        }
      }

      if (file.size / 1024 / 1024 > 100) {
        return {
          errMsg: this.$t('上传视频大小不能超过') + '100M'
        }
      }
      break
    case 'RTB-外投媒体（火山小视频）':
      if (file.type !== 'video/mp4') {
        return {
          errMsg: this.$t('上传视频只能是 MP4 格式')
        }
      }

      if (videoSize.width !== 540 & videoSize.height !== 960) {
        return {
          errMsg: this.$t('素材要求') + ': 540 * 960'
        }
      }

      if (file.size / 1024 / 1024 > 30) {
        return {
          errMsg: this.$t('上传视频小不能超过') + ' 30M'
        }
      }
      break
  }
  return {
    errMsg: '',
    imgSize: imgSize
  }
}
export default {
  components: {
    PreviewImg
  },
  props: {
    data: {
      type: Object,
      default () {
        return {
          media_type: []
        }
      }
    },
    fileLists: {
      type: Array,
      default () {
        return [[]]
      }
    },
    index: {
      // parentIndex
      type: Number,
      default () {
        return 0
      }
    },
    idx: {
      // childIndex
      type: Number,
      default () {
        return 0
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    handlePreview (url) {
      const index = this.fileLists[this.index][this.idx].findIndex(i => i.url === url)
      const res = this.fileLists[this.index][this.idx].filter(v => {
        return v.url.endsWith('.jpg') || v.url.endsWith('.jpeg') || v.url.endsWith('.gif') || v.url.endsWith('.png')
      }).map(i => {
        return {
          src: i.url,
          w: i.width,
          h: i.height
        }
      })
      this.$refs.PreviewImg.open(index, res)
    },

    async uploadFile (file, fileList, parentIndex, index) {
      const f = fileList.splice(-1, 1)
      const categoryName = this.data.media_type[parentIndex].media_type_category_name
      const errorMsg = await isFileValid(file.raw, categoryName)
      if (errorMsg.errMsg !== '') {
        this.$message.error(errorMsg.errMsg)
        return
      }
      fileList.push(f)

      const formData = new window.FormData()

      formData.append('file' + 1, file.raw)
      formData.append('file_type', 19)
      axios.post('/management/subfinal/saveFileNoMerge', formData)
        .then((res) => {
          if (errorMsg.imgSize.width != null) {
            res.width = errorMsg.imgSize.width
            res.height = errorMsg.imgSize.height
          }
          this.$emit('uploadSuccess', res, this.index, this.idx)
        })
    },
    getFileCover (url) {
      if (url.endsWith(('.pdf'))) {
        return postfixToImgCode.pdf
      } else if (url.endsWith('.mp4') || url.endsWith('.3gp') || url.endsWith('.avi') || url.endsWith('.mpeg')) {
        return postfixToImgCode.mp4
      } else if (url.endsWith('.xlsm') || url.endsWith('.xlsx')) {
        return postfixToImgCode.xlsx
      } else if (url.endsWith('.ppt')) {
        return postfixToImgCode.ppt
      } else if (url.endsWith('.doc')) {
        return postfixToImgCode.doc
      } else {
        return postfixToImgCode.other
      }
    },

    handleDownload (file) {
      window.open(file.url, '_blank')
    },

    handleRemove (file) {
      this.$emit('onDelete', file, this.index, this.idx)
    }
  }
}
</script>

<style lang='stylus'>
.upload-image-container
  .el-upload-list__item, .el-upload--picture-card
    width 80px !important
    height 80px !important
  .el-upload--picture-card
    align-items center
    justify-content center
    border-color $main
    background-color #edf2fa
    color $main
    i
      color $main
      margin-top 10px
  .action-btn-group
    width 650px
    display flex
    justify-content flex-end
    margin-top 32px
    margin-left 50px
    .el-button--text
      color #808080
    .el-button--default
      color #979797
      border-color #979797
      background #fffff
</style>
